import React, { Component } from 'react'
import WalletBalanceTabPanel from '../../../components/Tabs/WalletBalanceTabPanel'

class WalletBalanceTab extends Component {
    render() {
        return (
            <div>
              <WalletBalanceTabPanel />
            </div>
        )
    }
}

export default WalletBalanceTab;